module.exports.baseUrl = 'img/';
module.exports.manifest = [
    {name: 'gradient', url: '/include/gradient2.svg'},
    {name: 'm1', url: '/include/transitions/mtn/m1.svg'},
    {name: 'm2', url: '/include/transitions/mtn/m2.svg'},
    {name: 'm3', url: '/include/transitions/mtn/m3.svg'},
    {name: 'm4', url: '/include/transitions/mtn/m4.svg'},
    {name: 'm5', url: '/include/transitions/mtn/m5.svg'},
    {name: 'm6', url: '/include/transitions/mtn/m6.svg'},
    {name: 'm7', url: '/include/transitions/mtn/m7.svg'},
    {name: 'm8', url: '/include/transitions/mtn/m8.svg'},
    {name: 'm9', url: '/include/transitions/mtn/m9.svg'},
    {name: 'l1', url: '/include/scene0/l1.png'},
    {name: 'l2', url: '/include/scene0/l2.png'},
    {name: 'l3', url: '/include/scene0/l3.png'},
    {name: 'l5', url: '/include/scene0/l5.png'},
    {name: 'cl2', url: '/include/scene3/cl2.png'},
    {name: 'cl3', url: '/include/scene3/cl3.png'},
    {name: 'cl4', url: '/include/scene3/cl4.png'},
    {name: 'cl5', url: '/include/scene3/cl5.png'},
    {name: 'cl6', url: '/include/scene3/cl6.png'},
    {name: 'cl7', url: '/include/scene3/cl7.png'},
    {name: 'cl9', url: '/include/scene3/cl9.png'},
    {name: 'eyes', url: '/include/scene0/eyes.png'},
    {name: 'overshadows', url: '/include/scene0/overshadows.png'},
    {name: 'redMap', url: '/include/scene0/red_map_v2.png'},
    {name: 'blueMap', url: '/include/scene0/blue_map_v2.png'},
    {name: 'tajMahal', url: '/include/scene0/taj_mahal.jpg'},
    {name: 'introPart1Bg', url: '/include/scene1/bg.png'},
    {name: 'introPart1Solder1', url: '/include/scene1/solder_1.png'},
    {name: 'introPart1Solder1Bg', url: '/include/scene1/solder_1_bg.png'},
    {name: 'introPart1Solder2', url: '/include/scene1/solder_2.png'},
    {name: 'apotheosis', url: '/include/scene2/Apotheosis.jpg'},
    {name: 'beforeAttack', url: '/include/scene3/BeforeAttack.jpg'},
    {name: 'beforeAttackAlternative', url: '/include/scene3/Picture2.jpg'},
    {name: 'tajMahal_2', url: '/include/scene4/tajMahal_2.jpg'},
    {name: 'tajMahal_2_Alternative', url: '/include/scene4/Picture2.jpg'},
    {name: 'palestinian_1', url: '/include/scene5/palestinian_1.png'},
    {name: 'palestinian_2', url: '/include/scene5/palestinian_2.png'},
    {name: 'palestinians_Alternative', url: '/include/scene5/Picture2.jpg'},
    {name: 'galleryBg', url: '/include/scene6/bg.jpg'},
    {name: 'gallery_picBackCenter', url: '/include/scene6/picBackCenter.jpg'},
    {name: 'gallery_picBackLeft', url: '/include/scene6/picBackLeft.png'},
    {name: 'gallery_picBackRight', url: '/include/scene6/picBackRight.png'},
    {name: 'gallery_picFrontCenter', url: '/include/scene6/picFrontCenter.png'},
    {name: 'gallery_picFrontLeft', url: '/include/scene6/picFrontLeft.png'},
    {name: 'gallery_picFrontRight', url: '/include/scene6/picFrontRight.png'},

    {name: 'finBg', url: '/include/scene7/bg.png'},
    {name: 'info1', url: '/include/scene7/info1.png'},
    {name: 'info2', url: '/include/scene7/info2.png'},
    {name: 'info2_2', url: '/include/scene7/info2_2.png'},
    {name: 'info3', url: '/include/scene7/info3.png'},
    {name: 'p1_s1', url: '/include/scene7/p1_s1.png'},
    {name: 'p1_s2', url: '/include/scene7/p1_s2.png'},
    {name: 'p1_s3', url: '/include/scene7/p1_s3.png'},
    {name: 'p2_s1', url: '/include/scene7/p2_s1.png'},
    {name: 'p3_s1', url: '/include/scene7/p3_s1.png'},
    {name: 'p3_s2', url: '/include/scene7/p3_s2.png'},
    {name: 'p4_s1', url: '/include/scene7/p4_s1.png'},
    {name: 'p4_d1', url: '/include/scene7/p4_d1.png'},
    {name: 'p4_d2', url: '/include/scene7/p4_d2.png'},
    {name: 'p4_d3', url: '/include/scene7/p4_d3.png'},
    {name: 'p5_s1', url: '/include/scene7/p5_s1.png'},
    {name: 'p5_s2', url: '/include/scene7/p5_s2.png'},
    {name: 'p5_s3', url: '/include/scene7/p5_s3.png'},
    {name: 'p5_main', url: '/include/scene7/p5_main.png'},


    {name: 'ravenBase', url: '/include/transitions/ravenBase.svg'},
    {name: 'ravenKrilo1', url: '/include/transitions/raven/krilo1.svg'},
    {name: 'ravenKrilo2', url: '/include/transitions/raven/krilo2.svg'},
    {name: 'ravenTelo', url: '/include/transitions/raven/telo.svg'},
    {name: 'ravenNoga1', url: '/include/transitions/raven/noga1.svg'},
    {name: 'ravenNoga2', url: '/include/transitions/raven/noga2.svg'},
    {name: 'ravenHvost', url: '/include/transitions/raven/hvost.svg'},
    {name: 'ravenKluv', url: '/include/transitions/raven/kluv.svg'},
    {name: 'ravenYazik', url: '/include/transitions/raven/yazik.svg'}
];



/* Manifest format
 * [
 {name: 'key4', url: 'http://...', onComplete: function () {} },
 {url: 'http://...', onComplete: function () {} },
 'http://...',
 'http://...json'
 ]
 * */



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/Manifest.js